<template>
  <div class="page-error">
    <img :src="require('./error.png')" />
    <p class="error">{{ tips }}</p>
    <div style="margin-top: 28px;">
      <el-button v-if="showReload" type="primary" @click="reload">重试</el-button>
      <el-button @click="goLogin">重新登录</el-button>
    </div>
  </div>
</template>

<script>
  const loginTimeoutMinutes = 5 * 60 // 分
  const loginTimeOut = loginTimeoutMinutes * 60 * 1000
  const ERROR_TYPES = {
    1: '登录异常',
    2: '系统初始化失败(菜单异常)', // 菜单
    3: '系统初始化失败(权限异常)', // 权限
    4: '系统初始化失败(数字字典异常)', // 字典
    5: '登录已过期，请重新登录',
    9: '登录已超时，请重新登录'
  }
  export default {
    name: 'error',
    data () {
      const type = this.$route.query.type
      return {
        tips: ERROR_TYPES[type || '1'],
        showReload: type === '2' || type === '3'
      }
    },
    methods: {
      reload () {
        this.$router.replace('/')
      },
      goLogin () {
        // 重新登录判断是否页面超时，超时需要刷新
        let now = new Date().getTime()
        if ((now - window.ERP_LAST_REQUEST_TIME) > loginTimeOut) {
          this.$store.dispatch('logout')
        } else {
          if (this.$route.query.type === '9') {
            this.$store.dispatch('logout')
          } else {
            this.$store.dispatch('logout', this.$route.query.type)
          }
        }
      }
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.$store.state.oldPath = to.query.type === '5' ? from.fullPath : '/'
      })
    }
  }
</script>

<style lang='scss'>
  @import "index.scss";
</style>



// WEBPACK FOOTER //
// src/layout/layout/error-page/error.vue